module.exports = __webpack_public_path__ + "img/epic.7358b4b2.jpg";